import React, { type JSX } from 'react';
import {
  UrvalGQIDQuery as UrvalGQIDQueryData,
  UrvalGQIDQueryVariables,
} from './_QueryTypes/UrvalGQIDQuery';
import query from './UrvalGQIDQuery.gql';
import { ApolloError, useQuery } from '@apollo/client';

interface IProps {
  sysUrvalId: string | undefined;
  children: (params: {
    error?: ApolloError;
    loading: boolean;
    data?: UrvalGQIDQueryData;
  }) => JSX.Element;
}

const UrvalGQIDQuery: React.FunctionComponent<IProps> = props => {
  const queryResult = useQuery<UrvalGQIDQueryData, UrvalGQIDQueryVariables>(
    query,
    {
      variables: { sysUrvalID: props.sysUrvalId || '' },
      skip: !props.sysUrvalId,
    }
  );
  return props.children({
    error: queryResult.error,
    data: queryResult.data,
    loading: queryResult.loading,
  });
};

export default UrvalGQIDQuery;
